import { Component, Injectable, Input, Compiler } from '@angular/core';
import { NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { AlertService } from '../../../../../../app/utils/alert.service';
import { DataPackGroup } from '../../../../../../app/models/dataPackGroup.model';
import { DataPackLine } from '../../../../../../app/models/dataPackLine.model';
import { DataPackValue } from '../../../../../../app/models/dataPackValue.model';

import { ConsumeService } from '../../../../../../app/services/consume.service';

import { VoiceConsumeService } from '../../../../../../app/services/voice.consume.service';

  import * as _ from "lodash";

/**
 * @version $Id: content.component.ts 63831 2017-09-23 17:42:15Z edivaldo.m.junior $
 */
@Component({
  selector: 'smsNotification',
  templateUrl: './content.modal.template.html'
})
@Injectable()
export class SmsNotificationComponent {
  private static readonly MIN_DAYS: number = 0;
  private static readonly MAX_DAYS: number = 27;

  private saving: boolean = false;
  private pattern: string = '^([0-9]|[0-1][0-9]|[2][0-7])$'; //   '\\d+$' '^([0-9]\\|[0-1][0-9]\\|[2][0-7])$'
  private numberOfDays: string;
  
  constructor(private activeModal: NgbActiveModal, private voiceConsumeService: VoiceConsumeService, private consumeService: ConsumeService, private alertService: AlertService) {

  }

  ngOnInit() {
  }

  public activateSmsNotification() {
    this.saving = false;
    this.voiceConsumeService.activateSmsNotification (this.numberOfDays).subscribe(
      data => {
        this.saving = false;
        this.activeModal.dismiss();
        this.alertService.success(data['result']);
      },
      err => {
        this.saving = false;
        this.alertService.error(err.result, err);
      }
    );
  }
 
  private isDayValid(value: string) {
    let patt = new RegExp(this.pattern);
    return patt.test(value);
  }

  private close() {
    this.activeModal.dismiss();
  }

  private validateDay(event: any) {
    let patt = new RegExp(this.pattern);
    if (patt.test(event.target.value)) {
      if ((Number(event.target.value) < SmsNotificationComponent.MIN_DAYS) || (Number(event.target.value) > SmsNotificationComponent.MAX_DAYS)) {
        this.saving = false;
        this.alertService.error('Configuração inválida. Por favor reveja as configurações.',null);
      } else {
        this.saving = true;
      }
    } else {
      this.saving = false;
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/consume/voice/smsNotification/content.component.ts